import { render, staticRenderFns } from "./PaymentGate.vue?vue&type=template&id=60871166&"
import script from "./PaymentGate.vue?vue&type=script&lang=js&"
export * from "./PaymentGate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports